import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/about/about-client.tsx");
